import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { SubjectService } from 'src/app/services/subject.service';
import { TrackRequestService } from 'src/app/services/track-request.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { ErrorComponent } from '../error/error.component';

@Component({
  selector: 'app-confirmation-box',
  templateUrl: './confirmation-box.component.html',
  styleUrls: ['./confirmation-box.component.scss'],
})
export class ConfirmationBoxComponent implements OnInit {
  ERROR = "Your account couldn't be verified. Please try again using other number.";
  reserve: boolean;
  request: any;  
  language: any;


  constructor(
    private modalController: ModalController,
    private SS: SubjectService,
    private translate: TranslateService,
    private route: Router,
    private UTS: UtilitiesService,
    private TRS: TrackRequestService,
  ) {
    
    this.translate.get(['verification_failed']).subscribe((tData) => {
      this.ERROR = tData['verification_failed'];
    });

    this.SS.addonBuyError.subscribe((r: any) => {
      if (r) {
        this.reserve = false;
        this.ERROR = r;
        if (
          this.ERROR == 'null' ||
          this.ERROR == null ||
          this.ERROR == 'ERROR_RTF_VAL-00005' ||
          this.ERROR == 'ERROR_RTF_VAL-00007'||
          this.ERROR == 'ERROR_RTF_COMS-00001'
        ) {
          this.translate.get(['SORRY_ERROR']).subscribe((m) => {
            this.ERROR = m['SORRY_ERROR'];
          });
        }
        // if(this.ERROR ==  this.translate.instant('ERROR_VAL_00011')){
        //   this.reserve = true;
        // }
      }
    });
  }

  ngOnInit() {

    this.request = JSON.parse(localStorage.getItem('TR'));
    this.language = this.UTS.getLocaleLanguage();

  }

  ok() {
    this.dismiss();
  }

  cancel() {
    this.dismiss();
  }

  closePopUpEN() {
    this.dismiss();
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  goHome(){
    localStorage.clear();
    this.dismiss();
    this.route.navigateByUrl('/home')
  }

  yes(){
    const payload = {
      cqReferenceNo: this.request?.cqReferenceNo,
      category: "trackCQ",
      language: this.language.toLocaleLowerCase(),
      operationType: 'cancelCQ',
      // cqToken: this.request?.cqToken || ''
    };
    let language = localStorage.getItem('language') || 'en';
    this.TRS.handleCQOperations(payload).subscribe((r: any) => {
      if (r.statusCode == 200 || r.success == true) {
        //confiramtion screen
        this.dismiss();
        this.route.navigateByUrl(`/success?flow=rejected&orderId=${this.request?.cqReferenceNo}&locale=`+language)
      } else {
        this.openBottomSheet(ErrorComponent,{error: r.errorMessage, errorCode: 'rejected', cqRefNo: this.request?.cqReferenceNo,})
      }
    }, (e) => {
        this.UTS.error('ERROR')
             // error screen
    })
  }

  async openBottomSheet(component: any, data?: any) {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      // mode: "ios",
      cssClass: 'verification-modal modal-fullscreen',
    });
    return await modal.present();
  }

  
}
